import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function detenerFacturaRecurrente (params) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getNotification)
    })
  } else {
    const req = {
      url: '/api/facturas/detenerFacturaRecurrente',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { detenerFacturaRecurrente }
